module.exports = __webpack_public_path__ + "img/ctrl-pauli-stub-down--.0537af19.svg";